import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginVertical: indent,
  },
  label: {
    marginBottom: indent * 0.5,
  },
  value: {
    flexDirection: 'row',
  },
  attributeLine: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    paddingVertical: indent * 0.8,
  },
  borderTop: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  loadingBoxSubheader: {
    height: 30,
    width: 80,
  },
  loadingBoxOrderValue: {
    height: 20,
    width: 60,
  },
  loadingBoxScheduledDate: {
    height: 20,
    width: 80,
  },
  loadingBoxCV: {
    height: 20,
    width: 40,
  },
  loadingBoxRewardsBalance: {
    height: 20,
    width: 80,
  },
});
